import { Container, styled } from '@mui/material';
import { ReactElement } from 'react';
import { UserRole } from '@synergy/models';
import { useIsMobile } from '@synergy/components-next';

import { AccessControl } from '../../access-control/access-control';
import { CategoryTreeView } from '../category-tree-view/category-tree-view';
import { HeaderSearchBar } from './searchbar/header-search-bar';
import { ShoppingCart } from './shopping-cart/shopping-cart';
import { useAppSelector } from '../../../../store/store';
import { userSelector } from '../../../store/configuration-selectors';

const StyledDesktopContainer = styled(Container)(({ theme }) => ({
    height: 80,
    padding: theme.spacing(1, 0, 3),
    display: 'flex',
    gap: theme.spacing(3),

    [theme.breakpoints.down('sm')]: {
        height: 72,
        padding: theme.spacing(0.75, 1.75, 1),
    },
}));

export const SearchNavigation = (): ReactElement => {
    const isDesktop = !useIsMobile();
    const user = useAppSelector(userSelector);

    return (
        <StyledDesktopContainer maxWidth="xl">
            {isDesktop && <CategoryTreeView />}
            <HeaderSearchBar />
            {isDesktop && (
                <AccessControl user={user} allowedRoles={[UserRole.ShopAdmin, UserRole.ShopUser]}>
                    <ShoppingCart />
                </AccessControl>
            )}
        </StyledDesktopContainer>
    );
};
